export default __webpack_public_path__ + "static/media/MF.778ae79d.svg";